import {
  ADD_AREA,
  ADD_DISTRICT,
  ADD_STATE,
  GET_AREAS_DATA,
  GET_DISTRICTS_DATA,
  GET_STATES,
  UPDATE_AREA,
  UPDATE_AREA_STATUS,
  UPDATE_DISTRICT,
  UPDATE_DISTRICT_STATUS,
  UPDATE_STATE,
  UPDATE_STATE_STATUS,
} from "../actions/locationSettingType";

const initialState = {
  getStates: [],
  updateStateStatus: [],
  addStateData: [],
  updateStateData: [],
  getDistricts: [],
  updateDistrictStatus: [],
  addDistrictData: [],
  updateDistrictData: [],
  getAreas: [],
  updateAreaStatus: [],
  addAreaData: [],
  updateAreaData: [],
};
const getStatesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_STATES:
      return {
        ...state,
        getStates: payload,
      };
    case UPDATE_STATE_STATUS:
      return {
        ...state,
        updateStateStatus: payload,
      };
    case ADD_STATE:
      return {
        ...state,
        addStateData: payload,
      };
    case UPDATE_STATE:
      return {
        ...state,
        updateStateData: payload,
      };
    default:
      return state;
  }
};
const getDistrictsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_DISTRICTS_DATA:
      return {
        ...state,
        getDistricts: payload,
      };
    case UPDATE_DISTRICT_STATUS:
      return {
        ...state,
        updateDistrictStatus: payload,
      };
    case ADD_DISTRICT:
      return {
        ...state,
        addDistrictData: payload,
      };
    case UPDATE_DISTRICT:
      return {
        ...state,
        updateDistrictData: payload,
      };
    default:
      return state;
  }
};
const getAreasReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_AREAS_DATA:
      return {
        ...state,
        getAreas: payload,
      };
    case UPDATE_AREA_STATUS:
      return {
        ...state,
        updateAreaStatus: payload,
      };
    case ADD_AREA:
      return {
        ...state,
        addAreaData: payload,
      };
    case UPDATE_AREA:
      return {
        ...state,
        updateAreaData: payload,
      };
    default:
      return state;
  }
};

export { getStatesReducer, getDistrictsReducer, getAreasReducer };
